import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { useTableUiTheme } from '../../contexts/TableUiThemeContext';
import { cn } from '../../lib/utils';
import TableUiThemeSwitcher from '../TableUiThemeSwitcher';
import UiSidebarLayoutToggles from '../UiSidebarLayoutToggles';
import { getSelectableThemes } from '../../config/uiPreferences';

/**
 * Profile → Appearance: color theme + Κλασικό / Νέο (saved per user via API).
 */
const AppearanceSettingsPanel = () => {
  const { currentTheme, themes, changeTheme, theme, isDark } = useTheme();
  const { themeId } = useTableUiTheme();
  const selectable = getSelectableThemes(themes);

  return (
    <div className="space-y-6">
      <div>
        <h4 className={cn('text-sm font-semibold mb-1', theme.text.primary)}>Sidebar</h4>
        <UiSidebarLayoutToggles />
      </div>

      <div>
        <h4 className={cn('text-sm font-semibold mb-1', theme.text.primary)}>Εμφάνιση πινάκων</h4>
        <p className={cn('text-xs mb-3', theme.text.muted)}>
          Κλασικό ή Νέο — πίνακες, badges, dashboards. Αποθηκεύεται στον λογαριασμό σας.
        </p>
        <TableUiThemeSwitcher fullWidth />
      </div>

      <div>
        <h4 className={cn('text-sm font-semibold mb-1', theme.text.primary)}>Χρωματικό θέμα</h4>
        <p className={cn('text-xs mb-3', theme.text.muted)}>
          Χρώματα interface, sidebar και header.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {Object.entries(selectable).map(([key, data]) => {
            const active = currentTheme === key;
            return (
              <button
                key={key}
                type="button"
                onClick={() => changeTheme(key)}
                className={cn(
                  'flex items-center gap-3 px-4 py-3 rounded-lg border text-left w-full transition-all',
                  active
                    ? cn(
                        'ring-2 ring-blue-500/50',
                        isDark ? 'bg-blue-950/40 border-blue-800' : 'bg-blue-50 border-blue-200'
                      )
                    : cn(theme.border.light, isDark ? 'hover:bg-slate-800/80' : 'hover:bg-slate-50')
                )}
              >
                <span
                  className={cn(
                    'w-8 h-8 rounded-full shrink-0 border-2',
                    data.colors?.primary,
                    isDark ? 'border-slate-600' : 'border-white/80'
                  )}
                />
                <span className={cn('text-sm font-medium', theme.text.primary)}>{data.name}</span>
              </button>
            );
          })}
        </div>
      </div>

      <p className={cn('text-[11px]', theme.text.muted)}>
        Τρέχον: θέμα <span className="font-medium">{themes[currentTheme]?.name}</span>, πίνακες{' '}
        <span className="font-medium">{themeId === 'refined' ? 'Νέο' : 'Κλασικό'}</span>.
      </p>
    </div>
  );
};

export default AppearanceSettingsPanel;
